<template>
  <div v-if="parsed && topKeys.length">
    <v-tabs v-model="activeTab" background-color="primary" dark>
      <v-tab v-for="(key, idx) in topKeys" :key="key">{{ formatKey(key) }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="(key, idx) in topKeys" :key="key">
        <div class="json-block">
          <template v-for="(value, subKey) in parsed[key]">
            <div :key="subKey" class="json-item">
              <strong>{{ formatKey(subKey) }}:</strong>
              <div v-if="isObject(value)">
                <JsonDisplay :json="value" />
              </div>
              <div v-else>
                {{ value }}
              </div>
            </div>
          </template>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
  <div v-else>
    <span>No data available.</span>
  </div>
</template>

<script>
export default {
  name: "JsonDisplay",
  props: {
    json: {
      type: [Object, String],
      required: true
    }
  },
  data() {
    return {
      activeTab: 0
    };
  },
  computed: {
    parsed() {
      let val = this.json;
      if (!val) return null;
      try {
        if (typeof val === "string") {
          val = JSON.parse(val);
          if (typeof val === "string") {
            val = JSON.parse(val);
          }
        }
        return val;
      } catch (e) {
        return null;
      }
    },
    topKeys() {
      return this.parsed ? Object.keys(this.parsed) : [];
    }
  },
  methods: {
    isObject(val) {
      return val && typeof val === "object" && !Array.isArray(val);
    },
    formatKey(key) {
      return key.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').replace(/^./, str => str.toUpperCase());
    }
  },
  components: {
    JsonDisplay: () => import('./JsonDisplay.vue')
  }
};
</script>

<style scoped>
.json-block {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 2px solid #eee;
}
.json-item {
  margin-bottom: 8px;
}
</style>